import React, { useState } from "react";

export default function UserBehaviourPanel({ user }) {

    const [selectedInterval, setSelectedInterval] = useState("Week 5");

    const intervals = [
        { label: "Week 1", score: 62, delta: -6 },
        { label: "Week 2", score: 65, delta: -3 },
        { label: "Week 3", score: 68, delta: 0 },
        { label: "Week 4", score: 71, delta: 3 },
        { label: "Week 5", score: 74, delta: 6 }
    ];

    return (
        <div style={{ display: "flex", gap: "20px", padding: "10px" }}>

            {/* Interval Scores */}
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "6px" }}>Score by Interval</div>
                {intervals.map(function (i) {
                    return (
                        <div key={i.label} style={{ marginBottom: "6px", cursor: "pointer" }} onClick={function () { setSelectedInterval(i.label); }}>
                            {i.label} – {i.score}%
                        </div>
                    );
                })}
            </div>

            {/* Variance */}
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "6px" }}>Variance vs Avg</div>
                {intervals.map(function (i) {
                    return (
                        <div key={i.label} style={{ color: i.delta >= 0 ? "green" : "red" }}>
                            {i.label} {i.delta >= 0 ? "+" : ""}{i.delta}%
                        </div>
                    );
                })}
            </div>

            {/* Selected Detail */}
            <div style={{ flex: 1 }}>
                <div style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "6px" }}>
                    Detail – {selectedInterval}
                </div>
                <div>Example: Q deviations, comments, flags etc here</div>
            </div>

        </div>
    );
}
